import classnames from 'classnames';
import React, { useRef } from 'react';

import { FocusContainer } from '@eika/focus-container';

import { ScrollToTopButton, useInViewport } from './ScrollToTopButton';

import './FocusMonitor.scss';

interface FocusMonitorProps extends React.PropsWithChildren {
    active: boolean;
    onEnter: () => void;
    onExit: () => void;
    disableExit?: boolean;
    className?: string;
    timeout?: number;
}

const FocusMonitor: React.FC<FocusMonitorProps> = ({
    onEnter,
    onExit,
    className,
    children,
    active,
    timeout,
    disableExit = false,
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const inViewport = useInViewport(ref);

    return (
        <FocusContainer
            className={classnames('focus-monitor', className, { active })}
            entry={active}
            timeOut={timeout}
            onEnter={onEnter}
            ref={ref}
            onExit={!disableExit ? onExit : () => null}
            returnFocus={false}
            setEntryUponFocusInside
        >
            {children}
            {active && <div className="backdrop" />}
            <ScrollToTopButton show={!inViewport && active} />
        </FocusContainer>
    );
};
export default FocusMonitor;
